import type { Transition, Variants } from 'framer-motion';

export const subtleEase: [number, number, number, number] = [
  0.22,
  1,
  0.36,
  1,
];

export const subtleTransition: Transition = {
  duration: 0.18,
  ease: subtleEase,
};

export const pageVariants: Variants = {
  initial: { opacity: 0, y: 6 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 4 },
};

export const staggerContainer: Variants = {
  initial: { opacity: 1 },
  animate: {
    opacity: 1,
    transition: {
      delayChildren: 0.02,
      staggerChildren: 0.035,
    },
  },
};

export const workflowStaggerContainer: Variants = {
  initial: { opacity: 1 },
  animate: {
    opacity: 1,
    transition: {
      delayChildren: 0.03,
      staggerChildren: 0.04,
    },
  },
};

export const searchStaggerContainer: Variants = {
  initial: { opacity: 1 },
  animate: {
    opacity: 1,
    transition: {
      delayChildren: 0.01,
      staggerChildren: 0.025,
    },
  },
};

export const listItemVariants: Variants = {
  initial: { opacity: 0, y: 4 },
  animate: { opacity: 1, y: 0, transition: subtleTransition },
};